export default __webpack_public_path__ + "static/media/WorldBuilding.ada7f41b.jpg";